import React from "react";

const SuccessIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 14 15"
    stroke="#25B900"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="0.5" width="14" height="14" rx="7" fill="white" />
    <path
      d="M2.9165 7.75386L5.51182 10.3492L11.0832 4.77783"
      stroke="#25B900"
      strokeWidth="2"
    />
  </svg>
);

export default SuccessIcon;
